import Service, { service } from '@ember/service';
import { format } from 'date-fns';
import type AjaxFetchService from 'garaje/services/ajax-fetch';
import type { LENDING_STATUS } from 'garaje/utils/enums';
import urlBuilder from 'garaje/utils/url-builder';
import type { ValueOf } from 'type-fest';

export interface DeskLendingDateStatus {
  date: string;
  lendingStatus: ValueOf<typeof LENDING_STATUS>;
  reservation?: {
    reservationId: number;
    bookedByEmployeeId: number;
    bookedByName: string;
    bookedByEmail: string;
    startTime: string;
    endTime: string;
  } | null;
}

export interface DeskLendingStatusResponse {
  deskId: number;
  dates: DeskLendingDateStatus[];
}

export interface LendDeskResponse {
  lentDates: string[];
  assignmentsCreated: number;
}

export default class DeskLendingService extends Service {
  @service declare ajaxFetch: AjaxFetchService;

  async lendDesk(deskId: string, date: Date): Promise<LendDeskResponse> {
    const formattedDate = format(date, 'yyyy-MM-dd');
    const url = urlBuilder.rms.lendDesk(deskId);

    return this.ajaxFetch.post<LendDeskResponse>(url, {
      contentType: 'application/json',
      data: { dates: [formattedDate] },
    });
  }

  async fetchLendingStatus(deskId: string, startDate: Date, endDate: Date): Promise<DeskLendingStatusResponse> {
    const start = format(startDate, 'yyyy-MM-dd');
    const end = format(endDate, 'yyyy-MM-dd');
    const url = urlBuilder.rms.lendingStatus(deskId, start, end);

    return this.ajaxFetch.request<DeskLendingStatusResponse>(url);
  }
}

declare module '@ember/service' {
  interface Registry {
    deskLending: DeskLendingService;
  }
}
